import { defineComponent as l, ref as s, computed as t, resolveComponent as m, openBlock as n, createElementBlock as o, Fragment as u, createVNode as p, normalizeClass as f, toDisplayString as v, createCommentVNode as c } from "vue";
import { F, a as _ } from "../../../vee-validate.esm-c4518011.js";
import { _ as g } from "../../../_plugin-vue_export-helper-dad06003.js";
const y = l({
  name: "VFormFieldHidden",
  components: {
    Field: F
  },
  inheritAttrs: !1,
  props: {
    id: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Number, Boolean],
      default: ""
    },
    value: {
      type: [String, Number, Boolean],
      default: ""
    },
    showError: {
      type: Boolean,
      default: !1
    }
  },
  setup(e) {
    const { errorMessage: a } = _(e.name, void 0, {
      validateOnValueUpdate: !1,
      validateOnMount: !1,
      initialValue: e.value
    }), i = s();
    return {
      isInvalid: t(() => !!a && a.value !== void 0),
      errorMessage: a,
      inputFieldRef: i
    };
  }
});
const b = ["id"];
function h(e, a, i, r, V, I) {
  const d = m("Field");
  return n(), o(u, null, [
    p(d, {
      id: e.id,
      name: e.name,
      "model-value": e.modelValue,
      class: f(["hobi-input", { "hobi-input--invalid": e.isInvalid }]),
      type: "hidden",
      as: "input",
      "aria-describedby": `hobi-${e.name}-error-message`,
      "aria-invalid": e.isInvalid,
      ref: e.inputFieldRef
    }, null, 8, ["id", "name", "model-value", "class", "aria-describedby", "aria-invalid"]),
    e.showError && e.isInvalid ? (n(), o("p", {
      key: 0,
      id: `hobi-${e.name}-error-message`,
      class: "hobi-form-field-message"
    }, v(e.errorMessage), 9, b)) : c("", !0)
  ], 64);
}
const C = /* @__PURE__ */ g(y, [["render", h], ["__scopeId", "data-v-4f3ffe4a"]]);
export {
  C as default
};
